import React, { useState } from "react";
import { Button, Modal, Form, Row, Col } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { StyledButton } from "../../../../../components/styled-antd";
import { eContentFields } from "../constant";
import { RenderHelper } from "../../summary-employee-request/utils/render-helper";
import * as _ from "lodash";

export const EditTable = ({
  dataSource,
  setDataSource,
  index,
  indexParent,
}: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [form] = Form.useForm();

  const showModal = () => {
    form.resetFields();
    form.setFieldsValue(dataSource[indexParent].data[index]);

    setIsModalOpen(true);
  };

  const handleOk = async () => {
    // const validate = await form.validateFields();
    const values = form.getFieldsValue();
    let newDataSource = _.clone(dataSource);

    newDataSource[indexParent].data[index] = {
      ...newDataSource[indexParent].data[index],
      ...values,
    };

    setDataSource(newDataSource);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };

  return (
    <>
      <Button onClick={showModal} className="mb-3">
        <EditOutlined rev="data" />
      </Button>

      <Modal
        title="NHÂN SỰ ĐƯỢC THAY ĐỔI/BỔ SUNG KHÓA HỌC"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={"70%"}
      >
        <Form form={form}>
          <Row gutter={[32, 0]}>
            <RenderHelper fields={eContentFields} />

            <Col span={24}>
              <div className="flex-center">
                <StyledButton
                  bgColor="yellow"
                  type="primary"
                  htmlType="submit"
                  onClick={handleOk}
                >
                  Xác nhận
                </StyledButton>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
